import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataView } from "primereact/dataview";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import './Dashboard.css';

function Transaction({ selectedCase, refresh }) {
  
    const navigate = useNavigate();
    const [{ user}, dispatch] = useStateValue();
    const [data, setData] = useState(null);
    const [type, setType] = useState(null);

   
  
    useEffect(() => {
        
       
    }, [])

    
   
    useEffect(() => {
        if (typeof selectedCase !== 'undefined') {
            selectedCase.member === 'Yes' ? callBraintreeSubscription() : callBraintreeTransaction() ; 
        }
    }, [selectedCase])

   
    const callBraintreeTransaction = () => {
        var transactionId = selectedCase.transaction_id;
        const url = `api/braintree/transaction/${transactionId}`;

        const params = {

            "transactionId": transactionId
        }

        var endpoint = location.origin + '/' + url;
        axios.get(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.statusText === "OK") {

                    setData(response.data.data);
                    setType(response.data.type);

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });
    }
    const callBraintreeSubscription = () => {
        var subscriptionId = selectedCase.transaction_id;
        const url = `api/braintree/subscription/${subscriptionId}`;

        const params = {

            "subscriptionId": subscriptionId
        }

        var endpoint = location.origin + '/' + url;
        axios.get(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.statusText === "OK") {

                    setData(response.data.data);
                    setType(response.data.type);

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });
    }

    return (
        <div className="container mt-2">
            <div className="mt-0">
                {selectedCase && (
                    <div className="display-6">
                        {selectedCase.first_name && <span className="fs-2">{selectedCase.first_name} {selectedCase.middle_initial} {selectedCase.last_name} - {selectedCase.pharmacy_state}</span>}
                        <span className="ml-3 fs-4">Token: {selectedCase.token} {selectedCase.casetype === 'Case' ? 'Case:' + selectedCase.id : 'Refill:' + selectedCase.refillID}</span>
                    </div>
                )}
                <hr />
                <div className="card shadow-lg">
                    {data && (
                        <div className="card-body">
                            <h5>{type === 'subscription' ? 'Subscription Details' : 'Transaction Details'}</h5>
                            {type === 'subscription' ? (
                                <>
                                    <p><strong>Subscription ID:</strong> {data.Id}</p>
                                    <p><strong>Plan ID:</strong> {data.PlanId || 'N/A'}</p>
                                    <p><strong>Customer Name:</strong> {data.Transactions[0].CustomerDetails && `${data.Transactions[0].CustomerDetails.FirstName} ${data.Transactions[0].CustomerDetails.LastName}`}</p>
                                    <p><strong>Email:</strong> {data.Transactions[0].CustomerDetails && data.Transactions[0].CustomerDetails.Email}</p>
                                    <p><strong>Status:</strong> {data.Status}</p>
                                    <p><strong>Billing Period Start Date:</strong> {data.BillingPeriodStartDate ? new Date(data.BillingPeriodStartDate).toLocaleString() : 'N/A'}</p>
                                    <p><strong>Billing Period End Date:</strong> {data.BillingPeriodEndDate ? new Date(data.BillingPeriodEndDate).toLocaleString() : 'N/A'}</p>
                                    <p><strong>Next Billing Date:</strong> {data.NextBillingDate ? new Date(data.NextBillingDate).toLocaleString() : 'N/A'}</p>
                                    <p><strong>Price:</strong> ${data.Price}</p>
                                    <h6>Transaction Details</h6>
                                    {data.Transactions && data.Transactions.length > 0 && (
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Transaction ID</th>
                                                    <th>Amount</th>
                                                    <th>Payment Method</th>
                                                    <th>Transaction Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.Transactions.map((transaction, index) => (
                                                    <tr key={index}>
                                                        <td>{transaction.Id}</td>
                                                        <td>${transaction.Amount}</td>
                                                        <td>{transaction.PaymentInstrumentType}</td>
                                                        <td>{transaction.CreatedAt ? new Date(transaction.CreatedAt).toLocaleString() : 'N/A'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </>
                            ) : (
                                <>
                                        <p><strong>Transaction ID:</strong> {data.Id}</p>
                                        <p><strong>Plan ID:</strong> {data.PlanId || 'N/A'}</p>
                                        <p><strong>Customer Name:</strong> {data.CustomerDetails && `${data.CustomerDetails.FirstName} ${data.CustomerDetails.LastName}`}</p>
                                        <p><strong>Email:</strong> {data.CustomerDetails && data.CustomerDetails.Email}</p>
                                        <p><strong>Payment Method:</strong> {data.PaymentMethod && data.PaymentMethod.Type}</p>
                                        <p><strong>Amount:</strong> ${data.Amount}</p>
                                        <p><strong>Status:</strong> {data.Status}</p>
                                        <p><strong>Transaction Date:</strong> {data.CreatedAt ? new Date(data.CreatedAt).toLocaleString() : 'N/A'}</p>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

}
export default Transaction;